import script from "./UsersInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./UsersInfoModal.vue?vue&type=style&index=0&id=0dfee101&scoped=true&lang=css"

import exportComponent from "/home/runner/work/INPEOPLE-HUB/INPEOPLE-HUB/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dfee101"]])

export default __exports__